import { currentLocale, matches } from '@trello/locale';
import { State } from 'app/gamma/src/modules/types';
import {
  Announcement,
  getTacoShow,
  isUnread,
} from 'app/gamma/src/util/application-storage/announcements';

export const getAllAnnouncements = (state: State) => {
  return Object.values(state.models.announcements.collection).sort(
    (a, b) => (a.id < b.id ? 1 : a.id > b.id ? -1 : 0),
  );
};

export const getLocaleAnnouncements = (state: State) =>
  getAllAnnouncements(state).filter((announcement: Announcement) =>
    matches(announcement.locale, currentLocale),
  );

export const isLoading = (state: State) => {
  return (
    state.models.announcements.loading &&
    getAllAnnouncements(state).length === 0
  );
};

export const getUnreadAnnouncements = (state: State) => {
  return getLocaleAnnouncements(state).filter((announcement: Announcement) => {
    return isUnread(announcement.id);
  });
};

export const getUnreadAnnouncementCount = (state: State) => {
  return getUnreadAnnouncements(state).length;
};

export const includesDowntime = (state: State) => {
  return getLocaleAnnouncements(state).some(
    (announcement: Announcement) => announcement.type === 'downtime',
  );
};

export const isRecentlyRead = () => {
  return getTacoShow() > Date.now();
};
